import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton} from 'Components/Button';

import AddToCalendar from './AddToCalendar';

import {translation} from 'Services/TranslationHelpers';
import {translationFromJson} from 'Services/TranslationHelpers2';
import SmallButton from "Components/Button/SmallButton";

export default class AddToCalendarModal extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {agenda} = this.props;

        let event = {
            title: translationFromJson(agenda.title),
            description: '',
            location: process.env.MIX_APP_URL,
            startTime: agenda.start_date_time.iso_string,
            endTime: agenda.end_date_time.iso_string,
            timezone: 'UTC'
        };

        let filename = translationFromJson(agenda.title);

        return (
            <Modal>
                <ModalHeader
                    onClose={this.props.onClose}
                    childrenClassName="w-full text-center text-app-dark-blue font-bold uppercase"
                >
                    {translation('agenda', 'add_to_calendar')}
                </ModalHeader>

                <ModalBody>
                    <AddToCalendar event={event} filename={filename} />
                </ModalBody>

                <ModalFooter alignment="center">
                    <SmallButton text={translation('misc', 'close')} onClick={this.props.onClose} />
                </ModalFooter>
            </Modal>
        )
    }
};
